<template>
  <div class="chart-panel">
    <div class="chart-header">
      <!-- <div class="panel-title" style="float: left;cursor: pointer" @click="clickDetail">
        {{ title }}
        <i class="el-icon-d-arrow-right" style="margin-left: 10px"/>
      </div> -->
      <div class="time-selector-group">
        <div class="time-selector" :class="{ selected: $store.state[timeInterval] === '1h' }"
          @click="clickTime('h', $event)">
          近1小时
        </div>
        <div class="time-selector" :class="{ selected: $store.state[timeInterval] === '1d' }"
          @click="clickTime('d', $event)">
          近24小时
        </div>
        <div class="time-selector" :class="{ selected: $store.state[timeInterval] === '1w' }"
          @click="clickTime('w', $event)">
          近7天
        </div>
      </div>
      <!--      <div class="chart-detail-btn" @click="clickDetail">详情</div>-->
    </div>
    <stackedLineEchart v-show="dataY" ref="chart" :chartDataX="dataX" :chartDataY="dataY" :legendData="dataLegend"
      :show-date="this.$store.state.motorTimeRange === '1w'" :title="title"
      style="width: 100%; height: calc(100% - 20px)">
    </stackedLineEchart>
    <div v-show="!dataY" style="background-color: rgba(0, 0, 0, 0.301);height: calc(100% - 20px);display: flex;align-items: center;
    justify-content: center;color:var(--titleName-color)">暂无数据</div>

    <echartItemDialog ref="echartItemDialog"></echartItemDialog>
  </div>
  <!--  <echartItem-->
  <!--    :title="title"-->
  <!--    :sensorType="1"-->
  <!--    :lineChartDataX="dataX"-->
  <!--    :lineChartDataY="dataY"-->
  <!--    :legendData="dataLegend"-->
  <!--    echartType="stackedLine"-->
  <!--  ></echartItem>-->
</template>

<script>
import echartItem from "./echartItem.vue";
import echartItemDialog from "./echartItemDialog";
import stackedLineEchart from "./stackedLineEchart";
export default {
  components: { echartItem, echartItemDialog, stackedLineEchart },
  data() {
    return {
      dataX: [],
      dataY: [],
      dataLegend: [],
    };
  },
  props: {
    title: String,
  },
  mounted() {
    // this.$refs.chart.initChart();
    console.log("vibration chart mounted");
  },
  updated() {
    // this.$refs.chart.initChart();
  },
  methods: {
    clickDetail() {
      let vibrationSensorList = [];
      this.$store.state.curSensorList.forEach((item) => {
        //TODO 如果是扶梯，就不能按传感器类型来分类，要按监测部位来过滤掉
        if (item.sensorType === 1) {
          vibrationSensorList.push(item.edgeCode + "_" + item.usbPort);
        }
      });
      this.$refs.echartItemDialog.show(vibrationSensorList.join(","), 1);
    },
    setData(data) {
      if (!this.$refs.chart.chart) {
        this.$refs.chart.initChart();
      }
      this.dataX = data.chartDataX;
      this.dataY = data.chartDataY;
      // this.dataY[1].markPoint = {
      //     data: [
      //         { type: 'max', name: 'Max' }
      //     ]
      // }
      // console.log('dataY',this.dataY);
      this.dataLegend = data.dataLegend;
    },
    clickTime(t, e) {
      if (e.target.innerText === "近24小时") {
        localStorage.setItem(this.timeInterval, "1d");
        this.$store.state[this.timeInterval] = "1d";
      } else if (e.target.innerText === "近7天") {
        localStorage.setItem(this.timeInterval, "1d");
        this.$store.state[this.timeInterval] = "1w";
      } else {
        localStorage.setItem(this.timeInterval, "1h");
        this.$store.state[this.timeInterval] = "1h";
      }
    },
  },
  computed: {
    timeInterval: function () {
      if (this.title === "电机负载(ap)") {
        return "motorTimeRange";
      } else if (this.title === "电机负载(ap)2") {
        return "motorTimeRange2";
      } else if (this.title === "电机负载(ap)3") {
        return "escalatorTimeRange";
      } else if (this.title === "温度(°C)") {
        return "motorTimeRange";
      }else {
        return "escalatorTimeRange2";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.chart-panel {
  height: calc(100% - 17px);
  width: 100%;
  // background: url("../assets/chart-grid-bg.png");
}

.chart-header {
  height: 20px;
}

// .selected{
//   background-color:rgb(51,122,183);
//   color: white;
// }
</style>



// WEBPACK FOOTER //
// src/components/vibration-chart.vue